export const floorDecimal = (value: number, n: number) => {
  return Math.floor(value * Math.pow(10, n)) / Math.pow(10, n);
};
